import { FC } from 'react';
import { graphql, useFragment, useRelayEnvironment } from 'react-relay';
import { useRespUnavailableContext } from '../PdpRespUnavailableContext/PdpRespUnavailableContext';

// components
import { PdpRespHeroCarousel } from '../../PdpRespHeroCarousel/PdpRespHeroCarousel';

// types
import { PdpRespUnavailableHeroCarousel_item$key as Item } from './__generated__/PdpRespUnavailableHeroCarousel_item.graphql';
import { PdpRespUnavailableHeroCarousel_user$key as User } from './__generated__/PdpRespUnavailableHeroCarousel_user.graphql';
import { PdpRespUnavailableHeroCarousel_viewer$key as Viewer } from './__generated__/PdpRespUnavailableHeroCarousel_viewer.graphql';

const userFragment = graphql`
    fragment PdpRespUnavailableHeroCarousel_user on User {
        ...PdpRespHeroCarousel_user
    }
`;

const itemFragment = graphql`
    fragment PdpRespUnavailableHeroCarousel_item on Item {
        title
        firstPhotoWebPath(size: small)
        seller {
            isAccessible
        }
        ...PdpRespHeroCarousel_item
    }
`;

const viewerFragment = graphql`
    fragment PdpRespUnavailableHeroCarousel_viewer on Viewer {
        ...PdpRespHeroCarousel_viewer
    }
`;

export const PdpRespUnavailableHeroCarousel: FC<{
    item: Item;
    user: User | null;
    viewer: Viewer;
}> = ({ user: userRef, item: itemRef, viewer: viewerRef }) => {
    const user = useFragment(userFragment, userRef);
    const item = useFragment(itemFragment, itemRef);
    const viewer = useFragment(viewerFragment, viewerRef);
    const environment = useRelayEnvironment();
    const { title = '', firstPhotoWebPath = '', seller } = item;
    const { relayVars, currency } = useRespUnavailableContext();
    const { userId, itemId, isTrade, fetchUser, afterDisplay: isClient } = relayVars;

    return (
        <PdpRespHeroCarousel
            user={user}
            item={item}
            hideBubbles
            viewer={viewer}
            itemTitle={title}
            currency={currency}
            environment={environment}
            itemImage={firstPhotoWebPath}
            relayVariables={{
                userId,
                itemId,
                isTrade,
                isClient,
                fetchUser,
            }}
            disableRequestMoreImagesModal={!seller?.isAccessible}
        />
    );
};
